<template>
    <div>
        <NavbarOne/>

        <div class="flex">
            <div class="w-1/2 hidden md:block lg:flex-1" >
                <img class="h-full object-cover" :src="registerImg" alt="register">
            </div>
            <div class="w-full md:w-1/2 lg:max-w-lg xl:max-w-3xl lg:w-full py-16 px-[20px] sm:px-8 lg:p-16 xl:p-24 relative z-10 flex items-center overflow-hidden">
                <div class="mx-auto md:mx-0 max-w-md w-full">
                    <h2 class="leading-none" data-aos="fade-up">Create New Account</h2>
                    <p class="text-lg mt-[15px]" data-aos="fade-up" data-aos-delay="100">Create your client account for the website and mobile app.</p>
                    <form class="mt-7" @submit.prevent="submitRegister">
                        <div data-aos="fade-up" data-aos-delay="200">
                            <label class="text-base sm:text-lg font-medium leading-none mb-2.5 block dark:text-white">Full Name</label>
                            <input v-model="form.name" class="w-full h-12 md:h-14 bg-white dark:bg-transparent border border-bdr-clr focus:border-primary p-4 outline-none duration-300" type="text" placeholder="Enter your full name">
                            <p v-if="fieldErrors.name" class="mt-2 text-sm text-[#E13939]">{{ fieldErrors.name }}</p>
                        </div>
                        <div class="mt-5" data-aos="fade-up" data-aos-delay="300">
                            <label class="text-base sm:text-lg font-medium leading-none mb-2.5 block dark:text-white">Email</label>
                            <input v-model="form.email" class="w-full h-12 md:h-14 bg-white dark:bg-transparent border border-bdr-clr focus:border-primary p-4 outline-none duration-300" type="email" placeholder="Enter your email address">
                            <p v-if="fieldErrors.email" class="mt-2 text-sm text-[#E13939]">{{ fieldErrors.email }}</p>
                        </div>
                        <div class="mt-5" data-aos="fade-up" data-aos-delay="350">
                            <label class="text-base sm:text-lg font-medium leading-none mb-2.5 block dark:text-white">Phone</label>
                            <input v-model="form.phone" class="w-full h-12 md:h-14 bg-white dark:bg-transparent border border-bdr-clr focus:border-primary p-4 outline-none duration-300" type="text" placeholder="Type your phone number">
                            <p v-if="fieldErrors.phone" class="mt-2 text-sm text-[#E13939]">{{ fieldErrors.phone }}</p>
                        </div>
                        <div class="mt-5" data-aos="fade-up" data-aos-delay="400">
                            <label class="text-base sm:text-lg font-medium leading-none mb-2.5 block dark:text-white">Password</label>
                            <input v-model="form.password" class="w-full h-12 md:h-14 bg-white dark:bg-transparent border border-bdr-clr focus:border-primary p-4 outline-none duration-300 placeholder:text-xl placeholder:transform placeholder:translate-y-[10px]" type="password" placeholder="* * * * * * * *">
                            <p v-if="fieldErrors.password" class="mt-2 text-sm text-[#E13939]">{{ fieldErrors.password }}</p>
                        </div>
                        <div class="mt-5" data-aos="fade-up" data-aos-delay="450">
                            <label class="text-base sm:text-lg font-medium leading-none mb-2.5 block dark:text-white">Confirm Password</label>
                            <input v-model="form.password_confirmation" class="w-full h-12 md:h-14 bg-white dark:bg-transparent border border-bdr-clr focus:border-primary p-4 outline-none duration-300 placeholder:text-xl placeholder:transform placeholder:translate-y-[10px]" type="password" placeholder="* * * * * * * *">
                        </div>
                        <p v-if="generalError" class="mt-5 text-sm text-[#E13939]">{{ generalError }}</p>
                        <div data-aos="fade-up" data-aos-delay="600">
                            <button class="btn btn-theme-solid mt-[15px]" data-text="Register" :disabled="submitting">
                                <span>{{ submitting ? 'Creating account...' : 'Register' }}</span>
                            </button>
                        </div>
                    </form>
                    <p class="text-lg mt-[15px]" data-aos="fade-up" data-aos-delay="700">Already have an account ?<router-link to="/login" class="text-primary font-medium ml-1 inline-block">Login</router-link></p>
                </div>
            </div>
        </div>

        <FooterOne/>

        <ScrollToTop/>

    </div>
</template>

<script setup>
    import { onMounted, reactive, ref } from 'vue';
    import { useRouter } from 'vue-router';
    import NavbarOne from '@/components/navbar/navbar-one.vue';
    import FooterOne from '@/components/footer/footer-one.vue';
    import ScrollToTop from '@/components/scroll-to-top.vue';
    import registerImg from '@/assets/img/bg/register.jpg'
    import Aos from 'aos';
    import { useClientSession } from '@/composables/use-client-session';

    const router = useRouter();
    const session = useClientSession();

    const form = reactive({
        name: '',
        email: '',
        phone: '',
        password: '',
        password_confirmation: '',
    });

    const submitting = ref(false);
    const generalError = ref('');
    const fieldErrors = reactive({
        name: '',
        email: '',
        phone: '',
        password: '',
    });

    function resetErrors() {
        generalError.value = '';
        fieldErrors.name = '';
        fieldErrors.email = '';
        fieldErrors.phone = '';
        fieldErrors.password = '';
    }

    async function submitRegister() {
        resetErrors();
        submitting.value = true;

        try {
            await session.register(form);
            router.push('/my-profile');
        } catch (error) {
            const errors = error.errors || {};
            fieldErrors.name = errors.name ? errors.name[0] : '';
            fieldErrors.email = errors.email ? errors.email[0] : '';
            fieldErrors.phone = errors.phone ? errors.phone[0] : '';
            fieldErrors.password = errors.password ? errors.password[0] : '';
            generalError.value = error.message;
        } finally {
            submitting.value = false;
        }
    }

    onMounted(async ()=>{
        Aos.init()

        try {
            await session.initializeSession();
            if (session.isAuthenticated.value) {
                router.replace('/my-profile');
            }
        } catch (error) {
            // no-op
        }
    })
</script>
